import {
  BufferTrackerReact as BufferTracker,
  Client,
} from '@buffer-mono/tracking-plan'

import type { ChannelCapabilityKey } from './config'

type State = 'enabled' | 'disabled'

type CommonProps = {
  organizationId?: string | null
  channelId: string
}

const getCommonPayload = ({
  organizationId,
  channelId,
}: CommonProps): {
  organizationId: string
  clientName: string
  channelId: string
} | null => {
  if (!organizationId) {
    return null
  }

  return {
    organizationId,
    clientName: Client.PublishWeb,
    channelId,
  }
}

export function trackLinkedInCapabilitiesSettingsViewed(
  args: CommonProps & {
    channelType: 'profile' | 'page'
    hasRequiredScope?: boolean | null
    isSyncEnabled?: boolean | null
    earnedCount?: number | null
    totalCount?: number | null
    selectedCapabilityKey?: ChannelCapabilityKey | null
  },
): void {
  const common = getCommonPayload(args)
  if (!common) {
    return
  }

  BufferTracker.linkedInCapabilitiesSettingsViewed({
    ...common,
    channelType: args.channelType,
    hasRequiredScope: args.hasRequiredScope,
    isSyncEnabled: args.isSyncEnabled,
    earnedCount: args.earnedCount,
    totalCount: args.totalCount,
    selectedCapabilityKey: args.selectedCapabilityKey,
  })
}

export function trackLinkedInCapabilitiesTableToggled(
  args: CommonProps & {
    expanded: boolean
    earnedCount: number
    totalCount: number
  },
): void {
  const common = getCommonPayload(args)
  if (!common) {
    return
  }

  BufferTracker.linkedInCapabilitiesTableToggled({
    ...common,
    expanded: args.expanded,
    earnedCount: args.earnedCount,
    totalCount: args.totalCount,
  })
}

export function trackLinkedInCapabilitiesSyncToggleClicked(
  args: CommonProps & {
    targetState: State
    currentState: State
    hasRequiredScope: boolean
    hasSelectedCapability: boolean
    selectedCapabilityKey?: ChannelCapabilityKey | null
  },
): void {
  const common = getCommonPayload(args)
  if (!common) {
    return
  }

  BufferTracker.linkedInCapabilitiesSyncToggleClicked({
    ...common,
    targetState: args.targetState,
    currentState: args.currentState,
    hasRequiredScope: args.hasRequiredScope,
    hasSelectedCapability: args.hasSelectedCapability,
    selectedCapabilityKey: args.selectedCapabilityKey,
  })
}

export function trackLinkedInCapabilitySelected(
  args: CommonProps & {
    capabilityKey: ChannelCapabilityKey
    previousCapabilityKey?: ChannelCapabilityKey | null
    isFirstSelection: boolean
    isSyncEnabled: boolean
  },
): void {
  const common = getCommonPayload(args)
  if (!common) {
    return
  }

  BufferTracker.linkedInCapabilitySelected({
    ...common,
    capabilityKey: args.capabilityKey,
    previousCapabilityKey: args.previousCapabilityKey,
    isFirstSelection: args.isFirstSelection,
    isSyncEnabled: args.isSyncEnabled,
  })
}

export function trackLinkedInCapabilitiesRefreshClicked(
  args: CommonProps & {
    cta: string
  },
): void {
  const common = getCommonPayload(args)
  if (!common) {
    return
  }

  BufferTracker.linkedInCapabilitiesRefreshClicked({
    ...common,
    cta: args.cta,
  })
}
